import React from 'react';
import { ShoppingBagIcon } from 'lucide-react';
interface HeaderProps {
  orderCount: number;
  onOrderClick: () => void;
}
const Header: React.FC<HeaderProps> = ({
  orderCount,
  onOrderClick
}) => {
  return <header className="sticky top-0 z-10 bg-white shadow-sm" data-id="element-5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-6">
        <div className="flex justify-between items-center h-16" data-id="element-7">
          <div className="flex items-center" data-id="element-8">
            <h1 className="text-xl font-medium text-gray-800" data-id="element-9">
              Our Products
            </h1>
          </div>
          <button onClick={onOrderClick} className="relative p-2 text-gray-600 hover:text-[#d4b8c7] transition-colors" aria-label="View your order" data-id="element-10">
            <ShoppingBagIcon className="w-6 h-6" data-id="element-11" />
            {orderCount > 0 && <span className="absolute top-0 right-0 inline-flex items-center justify-center w-4 h-4 text-xs font-bold text-white bg-[#752F50] rounded-full transform translate-x-1/4 -translate-y-1/4" data-id="element-12">
                {orderCount}
              </span>}
          </button>
        </div>
      </div>
    </header>;
};
export default Header;